import SeriesPage from 'src/components/page/series'
export default SeriesPage